import { createInventoryBrandPage } from "../../../components/create-inventory-brand-page";
import db from "../../../utils/parts-racine.json";
export default createInventoryBrandPage("racine");

export async function getStaticProps() {
	return { props: { db } };
}
